module.exports = __webpack_public_path__ + "static/flux-wireframe-1-446094e52f66cc082ff1e83ae6a0b14b.png";